export default __webpack_public_path__ + "media/3.55271.png";